import { GET_QUOTAS, UPDATE_QUOTAS_REDUCE} from './../constants';
import { handleActions } from "redux-actions"

export const quotas = handleActions(
  { 
    [ GET_QUOTAS ]: (state, action) => action.payload,
    [ UPDATE_QUOTAS_REDUCE ]: (state, action) => action.payload
  }, []
)